import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';
import type { PaymentMethod } from './types';

type Variables = {};
type Response = PaymentMethod[];

export const useCustomerPaymentMethods = createQuery<
  Response,
  Variables,
  AxiosError
>({
  queryKey: ['customers/payment-methods'],
  fetcher: () => {
    return client
      .get('v2/customers/payment-methods')
      .then((response) => response.data.data);
  },
});
